export default __webpack_public_path__ + "images/3dc16e390ca6be800c80a29b53dc86f5-television.webp";